import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { useField, useFormikContext } from 'formik';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { LinkButton } from 'components/Button';
import TextField from 'forms/fields/TextField';
import { getPointSuffix } from 'utils/plurals-declination';
import RangeField from 'forms/fields/RangeField';
import { formatNumber } from 'utils/format';
import PaymentBalanceLoginSlug from 'forms/fields/PaymentBalanceField/LoginSlug';
import PaymentBalanceEmptySlug from 'forms/fields/PaymentBalanceField/EmptySlug';
import Model from '../../../../model';

const { cnBlock, el } = bem('payment-balance-field');

import './index.sass'
import { MaxNumberTextField } from 'forms/fields/TextField/MaxNumberTextField';
import { FormikMaxNumberTextField } from 'forms/fields/TextField/FormikMaxNumberTextField';

const PaymentBalanceField = ({ className, price, mod = 'short' }) => {

    const { user, isAuthenticated} = Model.user;
    const [ rangeField ] = useField({ name: 'saleSum', type: 'range' });

    if (!isAuthenticated) {
        return <PaymentBalanceLoginSlug mod={mod} />
    }

    const balance = user?.balance;

    if (+balance === 0) {
        return <PaymentBalanceEmptySlug mod={mod}/>
    }

    const pointSuffix = getPointSuffix(balance)

    if (!window.isRuDomain) {
        return <KZPaymentBalanceField className={className} mod={mod} balance={balance} price={price} />
    }

    return (
        <div className={ cnBlock(className, mod) }>
            <div className={ el('customer-balance') }>
                <div className={ el('customer-balance-label') }>
                    <Icon name={ 'wallet' }/>
                    <Text>Ваш баланс</Text>
                </div>
                <div className={ el('customer-balance-value') }>
                    <Text serif>{ `${ formatNumber(balance) } ${ pointSuffix }` }</Text>
                </div>
            </div>
            <div className={ el('separator') }/>
            <div className={ el('balance-to-spend') }>
                <div className={ el('balance-to-spend-top') }>
                    <Text>Сколько списать баллов?</Text>
                </div>
                <div className={ el('text-field') }>
                    <FormikMaxNumberTextField name={ 'saleSum' } max={ Math.min(price, balance) } />
                </div>
                <div className={ el('balance-to-spend-range') }>
                    <RangeField { ...rangeField } max={ Math.min(price, balance) } min={ 0 } step={ 1 }/>
                </div>
            </div>
        </div>
    )
}

const KZPaymentBalanceField = ({ className, mod, price, balance }) => {
    const pointSuffix = getPointSuffix(balance)
    const { setFieldValue } = useFormikContext();
    useEffect(() => {
        setFieldValue('saleSum', +price);
    }, [price])
    return (
        <>
            <div className={ cnBlock(className, mod, 'kz') }>
                <div className={ el('customer-balance') }>
                    <div className={ el('customer-balance-label') }>
                        <Icon name={ 'wallet' }/>
                        <Text>Ваш баланс</Text>
                    </div>
                    <div className={ el('customer-balance-value') }>
                        <Text serif>{ `${ formatNumber(balance) } ${ pointSuffix }` }</Text>
                    </div>
                </div>
                <div className={ el('replenish-button')}>
                    <LinkButton to={'/foreign-payments'} mod={'transparent-gold'}>
                        <Text>Пополнить</Text>
                    </LinkButton>
                </div>
            </div>
        </>
    )
}

export default observer(PaymentBalanceField)
